import { api } from "./configs/axiosConfigs";

export const PreStudentAPI = {
  getPreStudents: async () => {
    const response = await api
      .get("/pre-student")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  getPreStudentsSearch: async (term) => {
    const response = await api
      .get(`/pre-student?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
};